import { defineComponent as _defineComponent } from 'vue'
import {Configuration} from "@/app/helpers/QueryParams";
import Option from "@/app/models/Option";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorEditionOption',
  props: {
    config: null,
    option: null
  },
  setup(__props: any) {

const props = __props as {
  config: Configuration;
  option: Option;
};



const optionPrice = computed(() => {
  return props.option.getMatrixPrice(props.config.duration, props.config.mileage)
})

const selected = computed(() => {
  return props.config.isOptionSelected(props.option)
})

function onColorChanged() {
  props.config.selectOption(props.option)
}


return { __sfc: true,props, optionPrice, selected, onColorChanged }
}

})